<template>
  <artmisads-modal @cancel="show = false" :open="show" :title="$t('seller.partnershipsPage.editModalTitle')" :width="1200" :footer="null">
    <div class="content-box">
    
    <div class="content-top">
      <div class="content-top-item">
        <div class="content-top-item-title">
          {{ $t('seller.brandsPage.selectedBrand') }}
        </div>
        <div class="content-top-item-content">
          <LogoImage :logoUrl="formData?.associateBrandVO?.logoImageUrl"
            :brandName="formData?.associateBrandVO?.amazonBrandName" :width="28" :height="28" :fontSize="6"
            :borderRadius="4" />
          <div class="brand-name">
            {{ formData?.associateBrandVO?.amazonBrandName }}
          </div>
        </div>
      </div>
      <div class="content-top-item">
        <div class="content-top-item-title">
          {{ $t('seller.publishersPage.labelPublisherColon') }}
        </div>
        <div class="content-top-item-content">
          <LogoImage :logoUrl="formData?.publisherVO?.publicImage" :brandName="formData?.publisherVO?.creatorName"
            :width="28" :height="28" :fontSize="6" :borderRadius="4" />
          <div>
            {{ formData?.publisherVO?.creatorName }}
          </div>
        </div>
      </div>
    </div>
    <div class="commissions">
      <div class="top-title">
        {{ $t('seller.brandsPage.commissionRate') }}
      </div>
      <div class="content">
        <div class="commission">
          <div class="commission-input">
            <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
            <artmisads-input-number :placeholder="$t('seller.common.pleaseEnter')" :min="0" :max="100" suffix="%" :step="0.5"
              size="large" @blur="commissionBlur" v-model:value="commission" @change="handleChangeCommission($event)" />

          </div>
          <span>+</span>
          <div class="fees" ref="fees">
            <span>{{ $t('seller.brandsPage.artemisAdsFees') }}
              <!-- <a-tooltip :getPopupContainer="() => $refs.fees">
                <template #title>Publisher Commission x 20%, Max 3.5%</template>
                <Icon name="wenhao-tianchong" class="question-icon" />
              </a-tooltip> -->
            </span>
            <artmisads-button disabled>
              <!-- {{ fees.toFixed(1) }}% -->
              3.0%
            </artmisads-button>
          </div>
          <span>=</span>
          <div class="total">
            <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
            <artmisads-button disabled>
              <span>{{
                commission
                  ? parseFloat(3 + Number(commission)).toFixed(1)
                  : 3.0
              }}</span>
              <span>%</span>
            </artmisads-button>
          </div>
        </div>
        <div class="collaboration-section" ref="setCommissionRef">
          <div class="section-title">{{ $t('seller.brandsPage.collaborationPeriod') }}</div>
          <div class="date-row">
            <div class="date-group">
              <div class="date-label">{{ $t('seller.brandsPage.startDate') }}</div>
              <a-date-picker disabled v-model:value="formData.startDate" :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD"
                class="date-picker" :disabled-date="disabledStartDate" @change="handleStartDateChange"
                :getPopupContainer="() => $refs.setCommissionRef" />
            </div>
            <div class="date-group">
              <div class="date-label">{{ $t('seller.brandsPage.endDate') }}</div>
              <a-date-picker :showToday="false" :disabled="isAutoRenew" :allowClear="true" close-on-select
                v-model:value="formData.endDate" :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD" class="date-picker"
                :disabled-date="disabledEndDate" :allow-clear="false" @change="handleEndDateChange"
                :getPopupContainer="() => $refs.setCommissionRef" />
            </div>

          </div>
        </div>
        <div class="auto-renew-section">
          <a-radio v-model:checked="isAutoRenew" @change="handleAutoRenewChange"
            @click="handleRadioClick">{{ $t('seller.brandsPage.continuous') }}</a-radio>
        </div>
      </div>
    </div>

    <div class="top" :style="{ alignItems: isCollapsed ? 'center' : 'flex-start' }">
      <Icon name="info-tianchong" class="tianchong" :style="{ marginTop: isCollapsed ? '' : '4px' }" />
      <div class="content">
        <div class="title">
        <div>
          <Icon
            :name="CURRENCY_MAPPER[amazonCountryCode].icon"
            class="icon"
          ></Icon>
          {{
            $t('seller.brandsPage.accPolicyHeading', {
              host: CURRENCY_MAPPER[amazonCountryCode].host,
            })
          }}
        </div>
        <div class="collapse" :style="{margin: isCollapsed ? '0' : '16px 0'}" @click="isCollapsed = !isCollapsed" v-if="isCollapsed">
          <span class="collapse-style">
            {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
          </span>
          <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />

        </div>
        </div>
        <transition name="fade-slide">
          <div v-if="!isCollapsed">
            <p class="content">
              {{ $t('seller.brandsPage.accPolicyIntro') }}
            </p>
            <div class="bottom-content">
              <div class="item">
                <div class="item-top">
                  <div class="circle">
                    <div></div>
                  </div>
                  <div class="text">
                    {{ $t('seller.brandsPage.accPolicyCase1Title') }}
                  </div>
                </div>

                <div class="text-bottom">
                  {{ $t('seller.brandsPage.accPolicyCase1Body') }}
                </div>
              </div>

            </div>
            <div class="bottom-content">
              <div class="item">
                <div class="item-top">
                  <div class="circle">
                    <div></div>
                  </div>
                  <div class="text">
                    {{ $t('seller.brandsPage.accPolicyCase2Title') }}
                  </div>
                </div>

                <div class="text-bottom">
                  {{ $t('seller.brandsPage.accPolicyCase2Body') }}
                </div>
              </div>

            </div>
            <div class="bottom-btn">
            <div class="btn-style" v-if="isAcc" @click="handleCheckAuthorization">
                <Icon name="tiaozhuan" class="tiaozhuan" />
                <span class="text-style">{{ $t('seller.brandsPage.checkAccAuthorization') }}</span>
              </div>
              <div v-else>
              
              </div>
              <div class="collapse" @click="isCollapsed = !isCollapsed">
                <span class="collapse-style">
                  {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
                </span>
                <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />

              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="bottom-btn">
      <div>
        <div class="left-time" v-if="showTime">
          <span class="title">{{ $t('seller.setPublicCommission.effectiveTimeLabel') }}</span>
          <span class="content">{{ timeYYYY }} 00:00:00</span>
          <a-popover placement="top" trigger="hover">
            <template #content>
              <div class="popover-content">
                <p class="content" style="margin-bottom: 16px;">
                  {{ $t('seller.setPublicCommission.effectiveIncrease') }}
                </p>
                <p class="content">
                  {{ $t('seller.setPublicCommission.effectiveDecrease') }}
                </p>
              </div>
            </template>
            <Icon name="wenhao-tianchong" class="question" />
          </a-popover>
        </div>
      </div>

      <div class="btn-box">
        <artmisads-button type="default" @click="show = false">
          {{ $t('seller.common.cancel') }}
        </artmisads-button>
        <artmisads-button type="primary" @click="submit">
          {{ $t('seller.common.confirm') }}
        </artmisads-button>
      </div>
    </div>
      
    </div>
  </artmisads-modal>
</template>
<script setup>
import i18n from '~/i18n'
import { useI18n } from 'vue-i18n'

import LogoImage from '@/components/LogoImage.vue'
import { publishersApi } from '@/server'
import { ref, defineExpose, watch, reactive,computed } from 'vue'
import Icon from '@/components/Icon.vue'
import moment from 'moment'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useUserInfoStore } from '@/storeData/index'
import { message } from 'ant-design-vue'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import { useSystemStore } from '@/storeData/system'

const { t } = useI18n()
const systemStore = useSystemStore()
const isAcc = computed(() => systemStore.isAcc)
const isCollapsed = ref(false)
const amazonCountryCode = ref('')
const store = useUserInfoStore()
const userInfo = store.userInfo
const isAutoRenew = ref(false)
const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const emit = defineEmits(['updateData'])
watch(() => userInfo.countryCode, () => {
  amazonCountryCode.value = userInfo.countryCode
}, { immediate: true })
const formData = ref({
  startDate: '',
  endDate: '',
})
const show = ref(false)
const commission = ref('')
const initCommission = ref('')
const timeYYYY = ref('')
const showTime = ref(false)
const initData = (data) => {
  showTime.value = false
  show.value = true
  formData.value = data
  formData.value.startDate = data?.currentCommissionDetail?.startDateStr ? moment(data?.currentCommissionDetail?.startDateStr) : ''
  formData.value.endDate = data?.currentCommissionDetail?.endDateStr ? moment(data?.currentCommissionDetail?.endDateStr) : ''
  commission.value = data?.currentCommissionDetail?.commissionRate ?? ''
  initCommission.value = data?.currentCommissionDetail?.commissionRate ?? ''
}
function commissionBlur (e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data

}
const handleChangeCommission = (e) => {
  commission.value = e
 if (e) {
    showTime.value = true
    // 
    let nextWorkingDay = moment().tz(timezone)
    let workingDaysCount = 0
    if (commission.value > initCommission.value) {
     while (workingDaysCount < 1) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
    } else {
     while (workingDaysCount < 4) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
     
    }
     timeYYYY.value = nextWorkingDay.format('YYYY-MM-DD')
  }
  // dataSource.value.forEach(item => {
  //   if(commission.value>Number(item.accCommission.replace("%", ""))){
  //     item.commission =commission.value - Number(item.accCommission.replace("%", ""))
  //   }else{
  //     item.commission = 0
  //   }
  // })
}
const disabledStartDate = (current) => {
  // Start date should not be before today and should not be a weekend
  return current && current.isBefore(moment(), 'day')
}
const handleStartDateChange = (date) => {
  if (date) {
    formData.startDate = moment(date)

    // If end date exists and is before start date, clear end date
    if (formData.endDate && moment(formData.endDate).isBefore(moment(date), 'month')) {
      formData.endDate = null
    }
  }
}
const handleEndDateChange = (date) => {
  if (date) {
    const selectedEndDate = moment(date)

    // If end date is before start date, clear end date
    if (formData.startDate && selectedEndDate.isBefore(moment(formData.startDate), 'month')) {
      formData.value.endDate = null
      return
    }

    formData.value.endDate = selectedEndDate
  }
}
const disabledEndDate = (current) => {
  // End date should not be before start date, should not be before today, and should not be a weekend
  return current && ((formData.value.startDate && current.isBefore(formData.startDate)) || current.isBefore(moment()) || current.day() === 0 || current.day() === 6)
}
const handleAutoRenewChange = (e) => {

  if (isAutoRenew.value) {
    formData.value.endDate = moment('2099-12-31', 'YYYY-MM-DD')
  } else {
    formData.value.endDate = initEndDate.value
  }
}
const submit = async () => {
  if (!formData.value.startDate || !formData.value.endDate) {
    message.error(t('seller.msg.selectStartEndDate'))
    return
  }
  if (!commission.value) {
    message.error(t('seller.msg.pleaseInputCommission'))
    return
  }
  const commissionList = [
    {
      publisherId: formData.value?.publisherVO?.id,
      brandId: formData.value?.associateBrandVO?.id,
      commissionRate: commission.value,
      startDate: formData.value.startDate.format('YYYY-MM-DD'),
      endDate: formData.value.endDate.format('YYYY-MM-DD'),
      platformFeeRate: 3
    }
  ]

  const res = await publishersApi.updatePublisherCommissionBatch({ commissionList: commissionList })
  if (res.success) {
    message.success(i18n.global.t('seller.msg.partnershipSaved'))
    emit('updateData')
    show.value = false
  } else {
    message.error(res.error || i18n.global.t('seller.msg.updateFailed'))
  }
}
const handleCheckAuthorization = () => {
  window.open(`/seller/creatorConnections/authorization`)
}
defineExpose({
  initData
})
</script>
<style scoped lang="less">
.brand-name{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.collapse {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 16px 0;
  cursor: pointer;

  .jiantou {

    color: rgba(15, 6, 41, 0.9);
  }

  .collapse-style {
    color: rgba(15, 6, 41, 0.9);
    font-family: Sora;
    font-weight: 400;
    font-size: 14px;


  }
}

.popover-content {

  .content {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;

    .boldBlack {
      font-family: Sora;
      font-weight: 700;
      font-style: Bold;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 18px;
      letter-spacing: 0.3px;

    }
  }
}

.left-time {
  display: flex;
  align-items: center;
  gap: 8px;

  .title {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 0.7);

  }

  .content {
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 1);
  }

  .question {
    color: rgba(245, 155, 0, 1);
  }
}

.top {
  position: relative;
  display: flex;
  background-color: rgba(255, 245, 229, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
  box-shadow: 0px 1px 0px 0px rgba(15, 6, 41, 0.05);
  border: 1px solid rgba(255, 150, 25, 1);
  border-radius: 8px;
  padding: 16px;

  .tianchong {
    color: rgba(245, 155, 0, 1);

    margin-right: 16px;
    width: 16px;
    height: 16px;
  }

  .content {
    flex: 1;

    .title {
      font-family: Sora;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      margin-top: 10px;

    }

    .bottom-content {
      margin-top: 10px;

      .item {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 8px;
        padding: 12px 16px;

        .item-top {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .circle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 14px;
          height: 14px;

          border-radius: 50%;
          background: rgba(245, 155, 0, 0.2);

          >div {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: rgba(245, 155, 0, 1);
          }
        }

        .text {
          font-family: Sora;
          font-weight: 600;
          font-style: SemiBold;
          font-size: 13px;
          color: rgba(230, 130, 0, 1);

        }

        .text-bottom {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          color: rgba(15, 6, 41, 1);
        }
      }
    }
  }

  .bottom-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;

    .btn-style {
      cursor: pointer;
      display: flex;
      align-items: center;
      background-color: rgba(245, 155, 0, 1);
      border-radius: 90px;
      gap: 10px;
      padding: 6px 16px;

      .tiaozhuan {
        color: #fff;
      }

      .jiantou {}

      .text-style {
        color: #fff;
      }
    }

  }
}

.commissions {
  width: 100%;
  background-color: #fff;

  .top-title {
    font-family: Sora;
    font-weight: 600;
    font-size: 16px;


  }


  .commissions-item-title {
    font-family: Sora;
    font-weight: 600;
    font-size: 20px;
    color: rgba(15, 6, 41, 1);
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(232, 229, 237, 1);
  }

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    margin-top: 16px;
    // margin-bottom: 20px;

    .commission {
      display: flex;

      >span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        >span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        >button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          >span {
            align-self: center;
          }
        }
      }

      .fees {
        >button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        >button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }

    .collaboration-section {
      margin-bottom: 26px;
      margin-top: 26px;

      .section-title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 16px;
        font-style: normal;
        font-weight: 600;

        letter-spacing: 0.4px;
        opacity: 0.9;
        margin-bottom: 8px;
      }

      .date-row {
        display: flex;
        gap: 24px;

        .date-group {
          width: 324px;

          .date-label {
            font-size: 14px;
            color: rgba(15, 6, 41, 0.8);
            margin-bottom: 8px;
            font-weight: 500;
          }

          .date-picker {
            width: 100%;
          }
        }
      }
    }
  }
}
.content-box{
  height: 700px;
  overflow-y: auto;
  // position: relative;
}
.content-top {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;

  .content-top-item {
    width: 324px;
    height: 80px;
    angle: 0 deg;
    opacity: 1;
    border-radius: 8px;
    padding-top: 10px;
    padding-right: 16px;
    padding-bottom: 10px;
    padding-left: 16px;
    gap: 6px;
    background-color: rgba(80, 64, 128, 0.08);

    .content-top-item-title {
      font-family: Sora;
      font-weight: 500;
      font-size: 13px;
      color: rgba(15, 6, 41, 1);
      margin-bottom: 6px;
    }

    .content-top-item-content {
      display: inline-flex;

      align-items: center;
      gap: 6px;
      padding: 6px 8px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 8px;
      /* Ensure consistent height for all items */
      height: 32px;
      box-sizing: border-box;
      max-width: 100%;
      div {
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        color: rgba(15, 6, 41, 1);

      }
    }
  }
}

.bottom-btn {
  margin-top: 50px;
  display: flex;
  align-items: center;
  height: 56px;
  justify-content: space-between;
  border-top: 1px solid rgba(232, 229, 237, 1);
    position: sticky;
    bottom: 0;
    background-color: #fff;
  .btn-box {
    display: flex;
    gap: 12px;
  }
}

/* 动画效果 */
.jiantou {
  transition: transform 0.3s ease;
  transform: rotate(90deg);
}

.jiantou.rotate {
  transform: rotate(270deg);
}

/* 内容展开/折叠动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  overflow: hidden;
  opacity: 1;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}
</style>
